import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_user_create.routes';
import OemUserService from '../../../../components/api/oem_user/oem_user.service';

export class OemUserCreateController {
  /*@ngInject*/
  constructor($mdDialog, $state, OemUserService) {
    this.OemUserService = OemUserService;
    this.userData = {};
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.dialogs = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか？',
        ok: '作成する',
        cancel: '設定に戻る'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力内容を確認してください',
        ok: 'OK'
      }),
      duplication_error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力されたメールアドレスは既に登録されています。',
        ok: 'OK'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントを作成しました',
        content: '',
        ok: 'OK'
      })
    }
  }

  $onInit() {}

  showConfirm(userData, ev) {
    this.$mdDialog.show(this.dialogs.confirm.targetEvent(ev)).then(() => {
      this.OemUserService.oem_api.create(
        userData,
        res => {
          this.dialogs.success.content(`${this.userData.email} 宛にパスワード設定用のURLが通知されます。`);
          this.$mdDialog.show(this.dialogs.success)
            .finally(() => {
              this.$state.go('oem_main.oem_user_index');
            });
        },
        err => {
          if(err.data.message.email && err.data.message.email[0] === 'address is already in use') {
            this.$mdDialog.show(this.dialogs.duplication_error);
          } else {
            this.$mdDialog.show(this.dialogs.error);
          }
        }
      )
    })
  }
}

export default angular.module('leptonApp.oemUserCreate', [uiRouter, OemUserService])
  .config(routing)
  .component('oemUserCreate', {
    template: require('./oem_user_create.html'),
    controller: OemUserCreateController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/create/oem_user_create.component.js